import { Entity } from "../../Entity";
import AttachmentFactory from "../../Factories/AttachmentFactory";
import { FactoryInterface } from "../../FactoryInterface";

import { AttachmentInterface } from "./AttachmentInterface";

class Attachment extends Entity implements AttachmentInterface {

  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return AttachmentFactory;
  }

  get id(): number {
    return this.data.id;
  }

  get filename(): string {
    return this.data.filename;
  }

  get extension(): string {
    return this.data.extension;
  }

  get path(): string {
    return this.data.path;
  }

  get avatarPath(): string {
    return this.data.avatarPath;
  }

  get cropImgPath(): string {
    return this.data.cropImgPath;
  }

  get isAvatar(): boolean {
    return this.data.isAvatar;
  }

  get uuid(): string {
    return this.data.uuid;
  }

  get isPrivate(): boolean {
    return this.data.isPrivate;
  }

  get createdAt(): any {
    return this.data.createdAt;
  }

  get iconLink(): string {
    return this.data.iconLink;
  }

  get automaticallyCreated(): boolean {
    return this.data.automaticallyCreated;
  }
}

export { Attachment }
